import { MAX_WORD_LENGTH } from '../../constants/settings'
import { Cell } from './Cell'
import { unicodeSplit } from '../../lib/words'

type Props = {
  guess: string
  className: string
}

export const CurrentRow = ({ guess, className }: Props) => {
  const splitGuess = unicodeSplit(guess)
  const emptyCount = MAX_WORD_LENGTH - splitGuess.length
  
  const emptysecondCount = Math.min (4, emptyCount)
  const emptyfirstCount = Math.max (0, emptyCount - emptysecondCount)
  
  const emptyfirstCells = Array.from(Array(emptyfirstCount))
  const emptysecondCells = Array.from(Array(emptysecondCount))
  
  const splitfirstGuess = splitGuess.slice(0,4)
  const splitsecondGuess = splitGuess.slice(4)

  const classes = `flex justify-center mb-1 ${className}`
  const pointerclasses = 'w-8 h-14 flex items-center justify-center mx-0.5 text-4xl font-bold rounded dark:text-white'

  return (
    <div className={classes}>
	<div className={pointerclasses}>
    	<div className="letter-container">
			<br/>
		</div>
		</div>
		
      {splitfirstGuess.map((letter, i) => (
        <Cell key={i} value={letter} />
      ))}
	  
      {emptyfirstCells.map((_, i) => (
        <Cell key={i} />
      ))}
	  
	  <Cell key ="5" value="-" />
	  
	  {splitsecondGuess.map((letter, i) => (
        <Cell key={i} value={letter} />
      ))}
	  
      {emptysecondCells.map((_, i) => (
        <Cell key={i} />
      ))}
	  
	  <div className={pointerclasses}>
    	<div className="letter-container">
			<br/>
		</div>
		</div>
    </div>
  )
}
